import repository from "@/api/modules/Operations/WarehouseReturn";
import { makeAction } from "@/store/utils/createCrudModule";

export default {
  state: {
    view_dialog: false,
    status: 0,
    selected: {
      warehouse: "",
      series: "",
      remarks: "",
      created_by: "",
      created_at: "",
    },
  },
  getters: {
    WIR_VIEW_DIALOG: (state) => state.view_dialog,
    WIR_STATUS: (state) => state.status,
    WIR_SELECTED: (state) => state.selected,
  },
  actions: {
    warehouseReturnPost: makeAction(repository, "warehouseReturnPost", null, false),
    warehouseReturnGet: makeAction(repository, "warehouseReturnGet", null, false),
  },
  mutations: {
    WIR_VIEW_DIALOG: (state, data) => {
      state.view_dialog = data;
    },
    WIR_STATUS: (state, data) => {
      state.status = data;
    },
    WIR_SELECTED: (state, data) => {
      state.selected = data;
    },
  },
};
